module.exports = __webpack_public_path__ + "static/media/YM52_4.ca6b7262.jpg";